import Crud from '@/views/Worktime/Crud'
import Add from '@/views/Worktime/Add'

const routes = {
  path: '/worktime',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/worktime',
      name: 'list-journey',
      component: Crud,
    },
    {
      path: '/worktimes/add',
      name: 'Nova Jornada de Trabalho',
      component: Add,
    },
    {
      path: '/worktimes/edit/:id?',
      name: 'Editar Jornada de Trabalho',
      component: Add,
    },
  ],
}

export default routes
